import React from "react";
import { useState } from "react";
//import './searchBar.css';
//import './locationDropdown.css';
const LocationDropdown = ({
  newlocations,
  handleLocationSelect,
  selectedSuggestionIndex,
}) => {
  return (
    <div className="dropdown-location bg-white" >
      <ul
        className="list-unstyled jbscroll bg-white px-1 py-1 m-1 rounded-3"
        style={{ display: "block", maxHeight: "200px", height: "fit-content", overflowY: "scroll" }}
      >
        {newlocations.map((location, index) => (
          <li
            key={`${location}-${index}`} // Use a combination of location and index
            className="dropdown-item-location bg-white"
            onClick={() => handleLocationSelect(location)}
          >
            {location}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LocationDropdown;
